export default __webpack_public_path__ + "static/media/campaignDefault.909ec1e5.png";